import { render } from "./roles.vue?vue&type=template&id=6c3a5a89&scoped=true"
import script from "./roles.vue?vue&type=script&lang=js"
export * from "./roles.vue?vue&type=script&lang=js"

import "./roles.vue?vue&type=style&index=0&id=6c3a5a89&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3a5a89"]])

export default __exports__